import { DASHBOARD_LINK } from '@components/Router/constants'
import type React from 'react'
import { Navigate, useParams } from 'react-router-dom'

// Временная поддержка URL старого дашборда, удалённого в OCT-4929: живые
// ссылки на /projects и /team/:teamId ещё ходят по почте и закладкам, поэтому
// перекидываем их на равнозначный экран нового дашборда. Снести вместе с
// легаси-константами роутов, когда переходы по ним сойдут на нет.
export const LegacyDashboardRedirect: React.FC = () => {
  const { teamId = null, folderId = null } = useParams<{
    teamId: string
    folderId: string
  }>()

  const workspace = teamId ? `/${teamId}` : ''
  const folder = teamId && folderId ? `/${folderId}` : ''

  return <Navigate to={`${DASHBOARD_LINK}${workspace}${folder}`} replace />
}
